import React from 'react';
import { InputTextArea, Card } from 'components';
import { CreateListingCardProps, DescriptionFields } from '../types';
import { StyledGrid } from './StyledComponents';

type DescriptionProps = CreateListingCardProps<DescriptionFields> & {
  hasNarSettlement?: boolean;
};

const Description: React.FC<DescriptionProps> = ({
  client_remarks,
  brokerage_remarks,
  setListing,
  hasNarSettlement,
}) => {
  const autoSize = {
    minRows: 4,
    maxRows: 8,
  };

  return (
    <Card type="primary" title="Description" id="description">
      <StyledGrid $columns={2} $alignItems="flex-start">
        <InputTextArea
          label="Client Remarks"
          value={client_remarks}
          autoSize={autoSize}
          onChange={({ target: { value } }) =>
            setListing(prev => ({ ...prev, client_remarks: value }))
          }
          data-cy="listing-client-remarks"
        />
        <InputTextArea
          label="Brokerage Remarks"
          value={brokerage_remarks}
          autoSize={autoSize}
          onChange={({ target: { value } }) =>
            setListing(prev => ({ ...prev, brokerage_remarks: value }))
          }
          disabled={hasNarSettlement}
          data-cy="listing-brokerage-remarks"
        />
      </StyledGrid>
    </Card>
  );
};

export default React.memo(Description);
